import { ConfigReader } from '../config/configReader';

// 리뷰 상태 enum
export enum ReviewStatus {
  Submitted = 'Submitted',
  Published = 'Published',
  Curated = 'Curated',
}

export interface CreateReviewRequest {
  reviewId?: number; // Optional, auto-generated if not provided
  name: string;
  email?: string;
  rating: number;
  body: string;
  productId: number;
  title: string;
  files?: File[];
  skinType: string[];
  skinConcern: string[];
}

export interface ReviewResponse {
  productId: number;
  reviewId: number;
  name: string;
  rating: number;
  body: string;
  title: string;
  pictureUrls: string[];
  skinType: string[];
  skinConcern: string[];
  status: ReviewStatus;
  modifiedAt: string;
}

export class ReviewApi {
  private static readonly BASE_URL = ConfigReader.getApiDomain();

  static async createReview(data: CreateReviewRequest): Promise<ReviewResponse> {
    const formData = new FormData();
    if (data.reviewId !== undefined) {
      formData.append('reviewId', String(data.reviewId));
    }
    formData.append('name', data.name);
    formData.append('rating', String(data.rating));
    formData.append('body', data.body);
    formData.append('productId', String(data.productId));
    formData.append('title', data.title);
    formData.append('skinType', JSON.stringify(data.skinType));
    formData.append('skinConcern', JSON.stringify(data.skinConcern));
    if (data.files) {
      data.files.forEach((file) => formData.append('files', file));
    }
    const res = await fetch(`${ReviewApi.BASE_URL}/reviews`, {
      method: 'POST',
      body: formData,
    });
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
    return res.json();
  }

  static async getReviews(productId: number, status?: ReviewStatus): Promise<ReviewResponse[]> {
    let url = `${ReviewApi.BASE_URL}/reviews/product/${productId}`;
    if (status) {
      url += `?status=${encodeURIComponent(status)}`;
    }
    const res = await fetch(url);
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
    return res.json();
  }

  static async updateReview(
    productId: number,
    reviewId: number,
    data: Omit<CreateReviewRequest, 'productId' | 'reviewId'> & { status?: string },
  ): Promise<ReviewResponse> {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('rating', String(data.rating));
    formData.append('body', data.body);
    formData.append('title', data.title);
    formData.append('skinType', JSON.stringify(data.skinType));
    formData.append('skinConcern', JSON.stringify(data.skinConcern));
    if (data.status) {
      formData.append('status', data.status);
    }
    if (data.files) {
      data.files.forEach((file) => formData.append('files', file));
    }
    const url = `${ReviewApi.BASE_URL}/reviews?productId=${productId}&reviewId=${reviewId}`;
    const res = await fetch(url, {
      method: 'PUT',
      body: formData,
    });
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error);
    }
    return res.json();
  }
}
